import React from 'react';
import PropTypes from 'prop-types';

export default function LogoSpinner (props) {
  const {
    size,
    thickness,
    square
  } = props;

  return square ? (
    <svg data-testid='logo' className='st-logo-sq' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' viewBox='0 0 154.78 154.78' shapeRendering='geometricPrecision' width={size} height={size}>
      <g className='st-logo-sq-container'>
        <path className='st-logo-sq-line' d="M 149.70246,149.71238 149.70497,14.526227 86.41,95.12 67.93,80.39 10.644036,149.72057 Z" fill='none' stroke='#000' strokeWidth={thickness} strokeMiterlimit={thickness} />
      </g>
    </svg>
  ) : (
    <svg data-testid='logo' className='st-logo' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' viewBox='0 0 355.4 154.78' shapeRendering='geometricPrecision' width={size}>
      <g className='st-logo-container'>
        <path className='st-logo-line' d='M61.34726,149.72L10.557396,149.72L67.93,80.39L86.41,95.12L154.88,7.74L254.09,116.49L273.14,108.41L312.789967,149.72L103.58,149.72L163.88,73.88L182.28,92.3L239.79,27.29L351.7,149.72' fill='none' fillRule='evenodd' stroke='#000' strokeWidth={thickness} strokeMiterlimit={thickness} />
      </g>
    </svg>
  );
}

LogoSpinner.propTypes = {
  size: PropTypes.number.isRequired,
  thickness: PropTypes.number,
  square: PropTypes.bool
};

LogoSpinner.defaultProps = {
  thickness: 8,
  square: false
};
